<template>
	<div class="login-wrap">
		<div class="back-wrap" @click="toHome">返回首页</div>
		<div class="login">
			<div class="login-top">
				<img src="../assets/images/logo1.png" alt="" />
				<img src="../assets/images/login_icon4.png" alt="" />
			</div>
			<div class="login-bottom">
				<div class="tel">
					联系电话：010-56287933
				</div>
				<div class="con">
          学员登录各项系统出现、卡顿、登录错误等相关问题，请及时拨打技术部门电话进行协助处理。
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "login",
		data() {
			return {
				idCard: '',
				password: ''
			}
		},
		mounted() {
		},
		methods:{
			toHome(){
				this.$router.push({
				  path: '/'
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.login-wrap {
		background-image: url("../assets/images/login_bj.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;

		.back-wrap{
			cursor: pointer;
			position: absolute;
			right: 50px;
			top: 30px;
			padding: 10px 30px;
			border-radius: 20px;
			border: 1px solid #fff;
			color: #fff;
		}

		.login {
			width: 500px;
			.login-top{
				background-image: url(../assets/images/login_title.png);
				background-repeat: no-repeat;
				background-size: 100% 100%;
				width: 100%;
				height: 150px;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				img:nth-child(1){
					margin-bottom: 10px;
				}
			}
			.login-bottom{
				background-color: #fff;
				border-radius: 0 0 15px 15px;
				padding: 50px 50px;
				.tel{
					text-align: center;
					font-weight: bold;
					font-size: 25px;
					color: #1f8ba7;
					margin-bottom: 20px;
				}
				.con{
					font-size: 16px;
					text-indent: 32px;
					line-height: 25px;
				}
			}
		}
	}
</style>
